import React from "react";

import { compact, map } from "lodash/fp";

import { Stack } from "@mui/material";

import SettingAlert from "@app/analytics/account/components/SettingAlert";
import SettingMultiSelect from "@app/analytics/account/components/SettingMultiSelect";
import SettingsTitle from "@app/analytics/account/components/SettingsTitle";
import { SettingsModuleProps } from "@app/analytics/account/types";
import WorkspaceSettingsAccordion from "@app/analytics/account/WorkspaceSettings/components/WorkspaceSettingsAccordion";
import UpsellTooltipWrapper from "@app/analytics/components/UpsellTooltipWrapper";
import { EmailDigest } from "@app/analytics/types";
import { EMAIL_DIGEST_ID_BY_NAME } from "@app/common/workspaces/workspaceUtils";

import { EMAIL_DIGEST_FREQUENCY, MEETING_RECAP_VALUE } from "../constants";

const EmailDigestsModule = ({
  settings,
  onSettingUpdate,
  workspaceIsInactive,
}: SettingsModuleProps) => {
  const handleEmailPreferenceChange = (newValues: string[]) => {
    const newPreferences = compact(
      newValues.map((name) => ({
        id: EMAIL_DIGEST_ID_BY_NAME[name as EmailDigest],
        name: name as EmailDigest,
      }))
    ).filter((pref) => pref.id);
    onSettingUpdate({ emailPreferences: newPreferences });
  };

  const showEmailPreferencesRecommendation = !map(
    "name",
    settings.emailPreferences
  ).includes(MEETING_RECAP_VALUE);

  const emailDigestMultiSelectValues = map("name", settings.emailPreferences);

  return (
    <WorkspaceSettingsAccordion
      title="Email Digests"
      subtitle="Customize email frequency for users in this Workspace"
    >
      <Stack direction="column" spacing={3}>
        <Stack direction="column" spacing={1}>
          <SettingsTitle title={EMAIL_DIGEST_FREQUENCY.title} />
          <SettingAlert
            persist
            severity="info"
            show={showEmailPreferencesRecommendation}
          >
            For best results with a post-meeting survey, update this setting to
            include "After Every Meeting".
          </SettingAlert>
          <UpsellTooltipWrapper show={workspaceIsInactive} placement="right">
            <SettingMultiSelect
              disabled={workspaceIsInactive}
              {...EMAIL_DIGEST_FREQUENCY.multiSelect}
              value={emailDigestMultiSelectValues}
              onChange={handleEmailPreferenceChange}
            />
          </UpsellTooltipWrapper>
        </Stack>
      </Stack>
    </WorkspaceSettingsAccordion>
  );
};

export default EmailDigestsModule;
